import { render, staticRenderFns } from "./JobHeader.yaml?vue&type=template&id=0aad40f9&component"
import script from "./JobHeader.yaml?vue&type=script&lang=ts&component"
export * from "./JobHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports